import type { Key } from 'react';

import { sortByLocaleCompare } from '@src/utils/numberUtils';
import type { CompanyReportDto, ReportingBlockDto, ReportingPackageDto, ReportStructureDto } from '@src/api';

type ReportingTreeInterface = Omit<CompanyReportDto, 'id' | 'children'> &
  Omit<ReportingPackageDto, 'id' | 'children'> &
  ReportStructureDto &
  Omit<ReportingBlockDto, 'id' | 'children'>;

export interface TreeViewInterface extends ReportingTreeInterface {
  id: Key;
  key: Key;
  title: string;
  children?: TreeViewInterface[];
  parentId?: Key;
  isLeaf?: boolean;
}

// Строим дерево для Структуры отчетности
const reportingTreeToViewModel = (treeNode: TreeViewInterface): TreeViewInterface => {
  const { name, id, children, title, key, reportVersionName } = treeNode;

  let output = title || name || '';

  if (reportVersionName) {
    output = `${output} - ${reportVersionName}`;
  }

  return {
    ...treeNode,
    id: id ?? 0,
    key: key ?? id ?? 0,
    title: output,
    children: children?.length
      ? sortByLocaleCompare(children, 'name')?.map((child) => reportingTreeToViewModel(child))
      : undefined,
  };
};

export function toViewModel(reportingTree: TreeViewInterface[]): TreeViewInterface[] {
  return reportingTree.map((treeNode) => reportingTreeToViewModel(treeNode));
}
